class Tab{
	constructor(btn,target) {
		this.btn = btn;
		this.target = target;
	}

	exec(){
		const btn = $(this.btn);
		const target = $(this.target);

		btn.click(function() {
			let index = btn.index(this);

			target.hide();
			target.eq(index).fadeIn(600);

			btn.removeClass('active');
			$(this).addClass('active');

			return false;
		});
	}
}
module.exports = Tab;



// WEBPACK FOOTER //
// ./dev/js/scripts/Tab.js